// import consts from "@/consts.js";
import Request from './request'
import store from '../store'
import i18n from '@/i18n';
import snackbar from '@/plugins/snackbar';


async function fetch(id,data){
    return Request("get","api/quotations?supplier_id=" + id ,data)
}


async function fetchOne(id,data){
    return Request("get","api/quotations/" + id ,data)
}

function delSomeFields(data) {// 去除过多杂项
    data = JSON.parse(JSON.stringify(data));// 深拷贝避免修改原数据
    delete data.actions;
    // delete data.shop;
    delete data.order_activities;
    // delete data.bill;
    // delete data.creater;
    return data;
}

// 预览
async function addPreview(data) {// 新建预览
    data = delSomeFields(data);// 去除过多杂项
    return Request('post', "api/quotations/add-view", data);
}

async function add(data) {// 新建订单
    data = delSomeFields(data);// 去除过多杂项
    return Request('post', "api/quotations/add", data);
}

async function editPreview(data) {// 编辑预览
    data = delSomeFields(data);// 去除过多杂项
    return Request('patch', "api/quotations/add-view", data);
}

async function edit(id,data) {// 编辑订单
    data = delSomeFields(data);// 去除过多杂项
    return Request('patch', "api/quotations/edit?id=" + id, data);
}

// async function fetchByShop(id, data) {
//     if (!data) data = {};
//     data.limit = consts.limitAll; //获取全部
//     return Request('get', "api/material-templates/view-by-shop/" + id, data);
// }

async function exportOne(id){
    store.dispatch("fullscreenLoading");
    const response = await Request('post','api/quotations/export?id=' + id)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop");
    return response
}

async function inTemplateExport(data) {
    // 报价单导入模板下载
    store.dispatch('fullscreenLoading')
    const response = await Request('get', "api/quotations/quotation-template-export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function imports(file) {// 报价单导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/quotations/quotation-template-import", data);
}

async function getEconomyHistory(data) {
    return Request("get", "api/quotations/get-economy-history/", data)
}

export default {
    fetch,
    fetchOne,
    addPreview, add,
    editPreview, edit,
    // fetchByShop
    exportOne,
    inTemplateExport,
    imports,
    getEconomyHistory
}